import React from 'react';

import MechanicChatModal from '../../../../../components/user/maintain/mechanicchatmodal/MechanicChatModal.js';
import MyNavbar from '../../../../../components/user/general/mynavbar/MyNavbar.js';
import Footer from '../../../../../components/user/general/footer/Footer.js';

const CustomerMechanicTalkNow = () => {
  return (
    <>
      <MyNavbar />
      <MechanicChatModal isRentalAdmin={false} />
      <Footer />
    </>
  );
};

export default CustomerMechanicTalkNow;